import { useParams } from "react-router-dom"
import AttachList from "customerAttachments/components/AttachmentList"
import { AttachmentStatusMapping, TransferAttachMapping } from "customerAttachments/constants"
import { TransferAttachmentType } from "customerAttachments/types"

import useGetTransferAttachList from "./hooks/useGetTransferAttachList"

const TransferAttachList = () => {
  const { transferId = "" } = useParams<{ transferId: string }>()
  const { data, isLoading } = useGetTransferAttachList(transferId)

  const attachments =
    data?.map((item: TransferAttachmentType) => {
      const targetItem = TransferAttachMapping[item.AttachType as keyof typeof TransferAttachMapping] || {}
      const statusText = AttachmentStatusMapping[item.Status as keyof typeof AttachmentStatusMapping] || ""

      return {
        ...item,
        ...targetItem,
        Status: statusText,
        IsDisabled: false,
      }
    }) ?? []

  return <AttachList data={attachments} orderType="transfer" isLoading={isLoading} />
}

export default TransferAttachList
